/* Same-page navigation to the existing Shopify native bundle sections. */
(() => {
  if (!document.body.classList.contains('kiive-build-pdp')) return;
  const targetFor = (anchor) => {
    const hash = anchor.getAttribute('href');
    if (!hash || !hash.startsWith('#shopify-section-')) return null;
    const direct = document.getElementById(hash.slice(1));
    if (direct) return direct;
    const key = hash.slice('#shopify-section-'.length);
    return [...document.querySelectorAll('.shopify-section[id]')]
      .find((section) => section.id.endsWith(`__${key}`)) || null;
  };
  document.addEventListener('click', (event) => {
    const anchor = event.target.closest('a[href^="#shopify-section-"]');
    if (!anchor || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = targetFor(anchor);
    if (!target) return;
    event.preventDefault();
    const header = document.querySelector('[data-kvhdr-sticky]');
    const sticky = document.querySelector('.kvpdp__stickybar.is-visible');
    const offset = (header?.getBoundingClientRect().height || 0) +
      (sticky && getComputedStyle(sticky).position === 'fixed' ? sticky.getBoundingClientRect().height : 0) + 20;
    window.scrollTo({ top: window.scrollY + target.getBoundingClientRect().top - offset,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    const focus = target.querySelector('h2, h3, button, input, select');
    if (focus) {
      if (!focus.matches('button, input, select')) focus.setAttribute('tabindex', '-1');
      focus.focus({ preventScroll: true });
    }
  });
})();
